import WidgetManagement from './WidgetManagement';

export default WidgetManagement;
